import { Alert } from "ra-friendsofbabba";
import React from "react";
import { useTranslate } from "ra-core";

const DocsWarnSign = () => {
  const translate = useTranslate();
  return (
    <Alert severity="warning">
      <div
        dangerouslySetInnerHTML={{
          __html: translate("resources.projects.fields.docs.warn_sign"),
        }}
      />
    </Alert>
  );
};
export default DocsWarnSign;
